export default class ManufacturerType {
  static get Hot () { return 'hot' }
  static get Cold () { return 'cold' }
  static get Collector () { return 'collector' }

  static getName (enumValue) {
    switch (enumValue) {
      case ManufacturerType.Hot:
        return 'Горячий цех'

      case ManufacturerType.Cold:
        return 'Холодный цех'

      case ManufacturerType.Collector:
        return 'Сборка'

      default:
        return enumValue
    }
  }

  static getAllVariants () {
    const variants = [
      ManufacturerType.Cold,
      ManufacturerType.Hot,
      ManufacturerType.Collector,
    ]

    return variants.map(item => ({
      id: item,
      value: item,
      name: ManufacturerType.getName(item),
    }))
  }
}
